import Config from "../Config";
import { authHeader, handleResponse } from "../helpers/requestHelpers";

const config = new Config();

export function deleteInstance(licenseId) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(licenseId),
    };

    return function (dispatch) {
        return fetch(config.backendHost + "/licenses/deleteInstance", requestOptions)
            .then((response) => handleResponse(response))
            .then((json) => {
                return json;
            });
    };
}

export function getSyncTargets(licenseId) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(licenseId),
    };

    return function (dispatch) {
        return fetch(config.backendHost + "/licenses/getSyncTargets", requestOptions)
            .then((response) => handleResponse(response))
            .then((json) => {
                return json;
            });
    };
}

export function addInstanceToSyncTargets(sourceLicenseId, targetLicenseId) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify({ sourceLicenseId: sourceLicenseId, targetLicenseId: targetLicenseId }),
    };

    return function (dispatch) {
        return fetch(config.backendHost + "/licenses/addInstanceToSyncTargets", requestOptions)
            .then((response) => handleResponse(response))
            .then((json) => {
                return json;
            });
    };
}

export function removeInstanceFromSyncTargets(sourceLicenseId, targetLicenseId) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify({ sourceLicenseId: sourceLicenseId, targetLicenseId: targetLicenseId }),
    };

    return function (dispatch) {
        return fetch(config.backendHost + "/licenses/removeInstanceFromSyncTargets", requestOptions)
            .then((response) => handleResponse(response))
            .then((json) => {
                return json;
            });
    };
}
export function getAllLicensesByResellerId(resellerId) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(resellerId),
    };

    return function (dispatch) {
        return fetch(config.backendHost + "/licenses/getAllLicensesByResellerId", requestOptions)
            .then((response) => handleResponse(response))
            .then((json) => {
                return json;
            });
    };
}

export function getAvailableVersions() {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
    };

    return function (dispatch) {
        return fetch(config.backendHost + "/licenses/getAvailableVersions", requestOptions)
            .then((response) => handleResponse(response))
            .then((json) => {
                return json;
            });
    };
}

export function changeImageVersion(licenseId, containerImage) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify({ licenseId: licenseId, containerImage: containerImage }),
    };

    return function (dispatch) {
        return fetch(config.backendHost + "/licenses/changeImageVersion", requestOptions)
            .then((response) => handleResponse(response))
            .then((json) => {
                return json;
            });
    };
}

export function revokeLicense(licenseId, revokedReason) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify({ licenseId: licenseId, revokedReason: revokedReason }),
    };

    return function (dispatch) {
        return fetch(config.backendHost + "/licenses/revokeLicense", requestOptions)
            .then((response) => handleResponse(response))
            .then((json) => {
                return json;
            });
    };
}

export function reactivateLicense(licenseId) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(licenseId),
    };
    return function (dispatch) {
        return fetch(config.backendHost + "/licenses/reactivateLicense", requestOptions)
            .then((response) => handleResponse(response))
            .then((json) => {
                return json;
            });
    };
}

export function startInstance(projectName, instanceName) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify({
            projectName: projectName,
            instanceName: instanceName,
            licmanUrl: window.location.origin,
        }),
    };

    return function (dispatch) {
        return fetch(config.backendHost + "/licenses/startInstance", requestOptions)
            .then((response) => handleResponse(response))
            .then((json) => {
                return json;
            });
    };
}

export function stopInstance(projectName, instanceName) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify({
            projectName: projectName,
            instanceName: instanceName,
            licmanUrl: window.location.origin,
        }),
    };

    return function (dispatch) {
        return fetch(config.backendHost + "/licenses/stopInstance", requestOptions)
            .then((response) => handleResponse(response))
            .then((json) => {
                return json;
            });
    };
}

export function getLicenseById(licenseId, licmanUrl) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify({ licenseId: licenseId, licmanUrl: licmanUrl }),
    };

    return function (dispatch) {
        return fetch(config.backendHost + "/Licenses/getLicenseById", requestOptions)
            .then((response) => handleResponse(response))
            .then((json) => {
                return json;
            });
    };
}

export function getAllSubLicenses(resellerId) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(resellerId),
    };

    return function (dispatch) {
        return fetch(config.backendHost + "/licenses/getAllSubLicenses", requestOptions)
            .then((response) => handleResponse(response))
            .then((json) => {
                return json;
            });
    };
}

export function deploy(licenseId) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify({ licenseId: licenseId, licmanUrl: window.location.origin }),
    };

    return function (dispatch) {
        return fetch(config.backendHost + "/licenses/deployInstance", requestOptions)
            .then((response) => handleResponse(response))
            .then((json) => {
                return json;
            });
    };
}

export function addShopToLicense(licenseId, shopName, shopKind, url, image) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify({ licenseId: licenseId, shopName: shopName, shopKind: shopKind, url: url, image: image }),
    };

    return function (dispatch) {
        return fetch(config.backendHost + "/licenses/addShopToLicense", requestOptions)
            .then((response) => handleResponse(response))
            .then((json) => {
                return json;
            });
    };
}

export function getDeployStatus(licenseId) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(licenseId),
    };

    return function (dispatch) {
        return fetch(config.backendHost + "/licenses/getDeployStatus", requestOptions)
            .then((response) => handleResponse(response))
            .then((json) => {
                return json;
            });
    };
}

export function updateLicense(data) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return function (dispatch) {
        return fetch(config.backendHost + "/licenses/updateLicense", requestOptions).then((response) =>
            handleResponse(response)
        );
    };
}

export function insertLicense(data) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return function (dispatch) {
        return fetch(config.backendHost + "/licenses/insertLicense", requestOptions).then((response) =>
            handleResponse(response)
        );
    };
}

export function setupBios(licenceNumber, firstName, lastName, email, password) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify({
            licenceNumber: licenceNumber,
            firstName: firstName,
            lastName: lastName,
            email: email,
            password: password,
        }),
    };

    return function (dispatch) {
        return fetch(config.backendHost + "/licenses/setupBios", requestOptions).then((response) =>
            handleResponse(response)
        );
    };
}

export function deployWithoutToken(LicenseNumber) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(LicenseNumber),
    };

    return function (dispatch) {
        return fetch(config.backendHost + "/licenses/deployWithoutToken", requestOptions).then((response) =>
            handleResponse(response)
        );
    };
}

export function checkStoreName(storeName) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(storeName),
    };

    return function (dispatch) {
        return fetch(config.backendHost + "/licenses/checkStoreName", requestOptions).then((response) =>
            handleResponse(response)
        );
    };
}

export function checkCompanyKey(companyKey) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(companyKey),
    };

    return function (dispatch) {
        return fetch(config.backendHost + "/licenses/checkCompanyKey", requestOptions).then((response) =>
            handleResponse(response)
        );
    };
}

export function registerNewLicense(license) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(license),
    };

    return function (dispatch) {
        return fetch(config.backendHost + "/licenses/registerNewLicense", requestOptions).then((response) =>
            handleResponse(response)
        );
    };
}

export function getPaymentLink(license) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify({
            ownerFirstName: license.ownerFirstName,
            ownerLastName: license.ownerLastName,
            City: license.City,
            Street: license.Street,
            AddressDetails: license.AddressDetails,
            Zip: license.Zip,
            houseNumber: license.houseNumber,
            email: license.email,
            password: license.password,
            url: window.location.origin,
        }),
    };

    return function (dispatch) {
        return fetch(config.backendHost + "/payment/getPaymentLink", requestOptions).then((response) =>
            handleResponse(response)
        );
    };
}

export function checkPayment(tid, licenseId, firstName, lastName, email, password) {
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            tid: tid,
            licenseId: licenseId,
            firstName: firstName,
            lastName: lastName,
            email: email,
            password: password,
        }),
    };
    return function (dispatch) {
        return fetch(config.backendHost + "/payment/checkPayment", requestOptions).then((response) =>
            handleResponse(response)
        );
    };
}

export function generateApiKeyAndSecret(licenseId) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(licenseId),
    };

    return function (dispatch) {
        return fetch(config.backendHost + "/licenses/generateApiKeyAndSecret", requestOptions).then((response) =>
            handleResponse(response)
        );
    };
}
